import {
  setPermissions,
  getPermissions,
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
} from '@/api/roleserv'

export default {
  state: {
    state_Role_SetPermissionsResult: null,
    state_Role_GetPermissionsResult: null,
    state_Role_AddObjResult: null,
    state_Role_GetAllResult: null,
    state_Role_GetPageResult: null,
    state_Role_GetDetailResult: null,
    state_Role_ModifyObjResult: null,
    state_Role_DeleteObjResult: null,
  },
  mutations: {
    SET_ROLE_SETPERMISSIONS_RESULT: (state, rst) => {
      state.state_Role_SetPermissionsResult = rst;
    },
    SET_ROLE_GETPERMISSIONS_RESULT: (state, rst) => {
      state.state_Role_GetPermissionsResult = rst;
    },
    SET_ROLE_ADDOBJ_RESULT: (state, rst) => {
      state.state_Role_AddObjResult = rst;
    },
    SET_ROLE_GETALL_RESULT: (state, rst) => {
      state.state_Role_GetAllResult = rst;
    },
    SET_ROLE_GETPAGE_RESULT: (state, rst) => {
      state.state_Role_GetPageResult = rst;
    },
    SET_ROLE_GETDETAIL_RESULT: (state, rst) => {
      state.state_Role_GetDetailResult = rst;
    },
    SET_ROLE_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_Role_ModifyObjResult = rst;
    },
    SET_ROLE_DELETEOBJ_RESULT: (state, rst) => {
      state.state_Role_DeleteObjResult = rst;
    },
  },
  actions: {
    RoleServ_SetPermissions({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setPermissions(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ROLE_SETPERMISSIONS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ROLE_SETPERMISSIONS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RoleServ_GetPermissions({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPermissions(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ROLE_GETPERMISSIONS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ROLE_GETPERMISSIONS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RoleServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ROLE_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ROLE_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RoleServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ROLE_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ROLE_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RoleServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ROLE_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ROLE_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RoleServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ROLE_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ROLE_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RoleServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ROLE_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ROLE_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RoleServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ROLE_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ROLE_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_Role_SetPermissionsResult: state => {
      return state.state_Role_SetPermissionsResult;
    },
    get_Role_GetPermissionsResult: state => {
      return state.state_Role_GetPermissionsResult;
    },
    get_Role_AddObjResult: state => {
      return state.state_Role_AddObjResult;
    },
    get_Role_GetAllResult: state => {
      return state.state_Role_GetAllResult;
    },
    get_Role_GetPageResult: state => {
      return state.state_Role_GetPageResult;
    },
    get_Role_GetDetailResult: state => {
      return state.state_Role_GetDetailResult;
    },
    get_Role_ModifyObjResult: state => {
      return state.state_Role_ModifyObjResult;
    },
    get_Role_DeleteObjResult: state => {
      return state.state_Role_DeleteObjResult;
    },
  }
}